import {
  Component,
  Input,
  Optional,
  forwardRef,
  SkipSelf,
  OnInit,
  Injector,
  InjectFlags,
  ChangeDetectionStrategy,
  HostListener,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
  OnDestroy,
} from '@angular/core';
import { ControlValueAccessor, NgControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { debounceTime, Subscription } from 'rxjs';

@Component({
  selector: 'tablesready-color-picker',
  templateUrl: './color-picker.component.html',
  styleUrls: ['./color-picker.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TrColorPickerComponent),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class TrColorPickerComponent implements OnInit, ControlValueAccessor, OnDestroy {
  @ViewChild('pickerParentRef') pickerParentRef?: ElementRef;
  @Input() disabled: boolean;
  @Input() placeholder: string = '';
  @Input() type: 'text' | 'email' | 'password' = 'text';

  value: any = '';
  isPickerOpen = false;

  pickerLeft = 0;
  pickerTop = 0;
  pickerWidth = 200;
  pickerHeight = 270;
  pickerInverted = false;

  private readonly subscription = new Subscription();

  constructor(
    private readonly injector: Injector,
    @SkipSelf()
    @Optional()
    private formControl: NgControl,
    private readonly cdr: ChangeDetectorRef,
    private readonly breakpointObserver: BreakpointObserver,
  ) {
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  noBubble(interaction: MouseEvent | TouchEvent): void {
    interaction.stopPropagation();
  }

  calculateActualContentPosition(): void {
    if (!this.pickerParentRef) {
      return;
    }

    const rect = this.pickerParentRef?.nativeElement.getBoundingClientRect();
    this.pickerLeft = rect.left + window.scrollX - 8;
    this.pickerTop = 0;
    this.pickerInverted = false;

    this.cdr.detectChanges();

    setTimeout(() => {
      this.pickerInverted = window.innerHeight < rect.top + rect.height + this.pickerHeight;

      this.pickerTop = this.pickerInverted
        ? rect.top + window.scrollY - this.pickerHeight
        : rect.top + window.scrollY + rect.height;
      this.cdr.detectChanges();
    });
  }

  ngOnInit() {
    this.formControl = this.injector.get(
      NgControl,
      null,
      // eslint:disable-next-line: no-bitwise
      InjectFlags.Optional | InjectFlags.Host,
    );

    const orientationSub = this.breakpointObserver.observe([
      Breakpoints.HandsetPortrait,
      Breakpoints.HandsetLandscape,
      Breakpoints.TabletPortrait,
      Breakpoints.TabletLandscape,
      Breakpoints.WebPortrait,
      Breakpoints.WebLandscape,
    ])
      .pipe(debounceTime(100))
      .subscribe(() => {
        this.isPickerOpen = false;
        this.cdr.detectChanges();
      });
    this.subscription.add(orientationSub);
  }

  writeValue(value: any) {
    this.value = value;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  registerOnChange(fn: (_: any) => void) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  onblur() {
    this.onTouched();
  }

  onChange(_: string) {}
  private onTouched = () => {};
}
